package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.preview.PreviewSurface

/** Minimum space kept between a field's label and its value. */
private val FieldGap = 16.dp

@Composable
internal fun StationField(
    label: String,
    value: String,
) {
    // Each side may take at most half the row, so a long value (a company list, a URL) wraps within
    // its half instead of squeezing the label until it breaks mid-word, and vice versa. Whichever
    // side ends up taller, the other is centred against it.
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val sideMaxWidth = (maxWidth - FieldGap) / 2
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(
                text = label,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.widthIn(max = sideMaxWidth),
            )
            Text(
                text = value,
                style = MaterialTheme.typography.bodyMedium,
                textAlign = TextAlign.End,
                modifier = Modifier.widthIn(max = sideMaxWidth),
            )
        }
    }
}

@Preview
@Composable
private fun StationFieldPreview() {
    PreviewSurface {
        Column(
            modifier = Modifier.padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            StationField(label = "Capacity", value = "12")
            StationField(label = "Company", value = "Barcelona de Serveis Municipals, PBSC Urban Solutions, Moventia")
            StationField(label = "A label long enough to wrap onto a second line of its own", value = "Short")
        }
    }
}
